import React, { useState, useEffect } from "react";

import Sidebar from "./Sidebar/Sidebar";

const AdminAttendanceManagement = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({});
  const [showManualEntry, setShowManualEntry] = useState(false);
  const [employees, setEmployees] = useState([]);
  
  // Updated state - reason field removed
  const [manualForm, setManualForm] = useState({
    employeeId: "",
    date: new Date().toISOString().split("T")[0],
    status: "present",
    checkIn: "",
    checkOut: "",
  });

  useEffect(() => {
    fetchEmployeesAttendance();
    fetchEmployees();
  }, [selectedDate]);

  const fetchEmployeesAttendance = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_BASEURL}/api/attendance/all-employees?date=${selectedDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (data.success) {
        setAttendanceData(data.attendance);
        setSummary(data.summary);
      }
    } catch (error) {
      console.error("Error fetching attendance:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_BASEURL}/api/admin/users/active`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (data.success) {
        setEmployees(data.users);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  // Updated manual entry handler - reason field removed and timezone fix
 

const handleManualEntry = async (e) => {
  e.preventDefault();
  try {
    setLoading(true);
    const token = localStorage.getItem("authToken");

    const payload = {
      employeeId: manualForm.employeeId,
      date: manualForm.date,
      status: manualForm.status,
      reason: "Manual entry by admin"
    };

    
    if (manualForm.checkIn) {
     
      payload.checkIn = manualForm.checkIn; 
    }

    if (manualForm.checkOut) {
 
      payload.checkOut = manualForm.checkOut; 
    }

    console.log('Sending payload:', payload); // Debug 

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_BASEURL}/api/attendance/manual-entry`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();
    if (data.success) {
      alert("Manual attendance added successfully!");
      setShowManualEntry(false);
      setManualForm({
        employeeId: "",
        date: new Date().toISOString().split("T")[0],
        status: "present",
        checkIn: "",
        checkOut: "",
      });
      fetchEmployeesAttendance();
    } else {
      alert(data.message);
    }
  } catch (error) {
    console.error("Error adding manual attendance:", error);
    alert("Error adding manual attendance");
  } finally {
    setLoading(false);
  }
};

  // ✅ FIXED: Time formatting function with IST timezone
  const formatTime = (timeString) => {
    if (!timeString) return "-";
    
    try {
      const date = new Date(timeString);
      return date.toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Asia/Kolkata'
      });
    } catch (error) {
      console.error('Time formatting error:', error);
      return "-";
    }
  };

  const formatWorkingHours = (minutes) => {
    if (!minutes) return "-";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  };

  const getStatusColor = (status) => {
    const colors = {
      present: "#10B981", // Green-500
      late: "#F59E0B", // Amber-500
      absent: "#EF4444", // Red-500
      "half-day": "#0EA5E9", // Sky-500
      "on-leave": "#8B5CF6", // Violet-500
    };
    return colors[status] || "#6B7280"; // Gray-500
  };

  const getStatusBgColor = (status) => {
    const colors = {
      present: "bg-green-100",
      late: "bg-amber-100",
      absent: "bg-red-100",
      "half-day": "bg-sky-100",
      "on-leave": "bg-violet-100",
    };
    return colors[status] || "bg-gray-100";
  };

  const exportToCSV = () => {
    const headers = [
      "Employee Name",
      "Employee ID",
      "Department",
      "Status",
      "Check In",
      "Check Out",
      "Working Hours",
    ];
    const csvData = attendanceData.map((item) => [
      item.employee.name,
      item.employee.employeeId || "-",
      item.employee.department || "-",
      item.attendance.status || "absent",
      item.attendance.checkIn?.time
        ? formatTime(item.attendance.checkIn.time)
        : "-",
      item.attendance.checkOut?.time
        ? formatTime(item.attendance.checkOut.time)
        : "-",
      item.attendance.workingHours?.total
        ? formatWorkingHours(item.attendance.workingHours.total)
        : "-",
    ]);

    const csvContent = [headers, ...csvData]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `attendance-${selectedDate}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <div
        style={{
          marginLeft: "250px",
          flex: 1,
          padding: "24px",
          backgroundColor: "#F9FAFB" /* gray-50 */,
        }}
      >
        <div className="admin-attendance-management">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "24px",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div>
              <h2
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#111827" /* gray-900 */,
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "4px",
                }}
              >
                <i
                  className="fas fa-calendar-check"
                  style={{
                    marginRight: "12px",
                    color: "#4F46E5" /* indigo-600 */,
                  }}
                ></i>
                Attendance Management
              </h2>
              <p
                style={{
                  color: "#6B7280" /* gray-500 */,
                  fontSize: "14px",
                }}
              >
                Monitor and manage employee attendance 
              </p>
            </div>
            <div style={{ display: "flex", gap: "12px" }}>
              <button
                onClick={exportToCSV}
                disabled={attendanceData.length === 0}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px 16px",
                  backgroundColor: "#F3F4F6" /* gray-100 */,
                  color: "#4B5563" /* gray-600 */,
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "500",
                  fontSize: "14px",
                  cursor:
                    attendanceData.length === 0 ? "not-allowed" : "pointer",
                  opacity: attendanceData.length === 0 ? "0.7" : "1",
                  transition: "all 0.2s ease",
                }}
              >
                <i
                  className="fas fa-download"
                  style={{ marginRight: "8px" }}
                ></i>
                Export CSV
              </button>
              <button
                onClick={() => setShowManualEntry(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px 16px",
                  backgroundColor: "#4F46E5" /* indigo-600 */,
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "500",
                  fontSize: "14px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                <i className="fas fa-plus" style={{ marginRight: "8px" }}></i>
                Add Manual Entry
              </button>
            </div>
          </div>

          {/* Date Selector and Summary */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "24px",
              gap: "16px",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <label
                htmlFor="attendance-date"
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#374151" /* gray-700 */,
                  marginBottom: "8px",
                }}
              >
                Select Date:
              </label>
              <input
                id="attendance-date"
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
                style={{
                  padding: "8px 12px",
                  border: "1px solid #D1D5DB" /* gray-300 */,
                  borderRadius: "6px",
                  fontSize: "14px",
                  color: "#1F2937" /* gray-800 */,
                  outline: "none",
                  width: "200px",
                  transition: "border-color 0.2s ease",
                }}
              />
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "16px",
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      "rgba(16, 185, 129, 0.1)" /* green-500 with opacity */,
                    color: "#10B981" /* green-500 */,
                    width: "48px",
                    height: "48px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "16px",
                    fontSize: "20px",
                  }}
                >
                  <i className="fas fa-user-check"></i>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      color: "#111827" /* gray-900 */,
                      lineHeight: "1.25",
                    }}
                  >
                    {summary.present || 0}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#6B7280" /* gray-500 */,
                    }}
                  >
                    Present
                  </div>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      "rgba(239, 68, 68, 0.1)" /* red-500 with opacity */,
                    color: "#EF4444" /* red-500 */,
                    width: "48px",
                    height: "48px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "16px",
                    fontSize: "20px",
                  }}
                >
                  <i className="fas fa-user-times"></i>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      color: "#111827" /* gray-900 */,
                      lineHeight: "1.25",
                    }}
                  >
                    {summary.absent || 0}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#6B7280" /* gray-500 */,
                    }}
                  >
                    Absent
                  </div>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      "rgba(245, 158, 11, 0.1)" /* amber-500 with opacity */,
                    color: "#F59E0B" /* amber-500 */,
                    width: "48px",
                    height: "48px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "16px",
                    fontSize: "20px",
                  }}
                >
                  <i className="fas fa-user-clock"></i>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      color: "#111827" /* gray-900 */,
                      lineHeight: "1.25",
                    }}
                  >
                    {summary.late || 0}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#6B7280" /* gray-500 */,
                    }}
                  >
                    Late
                  </div>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      "rgba(79, 70, 229, 0.1)" /* indigo-600 with opacity */,
                    color: "#4F46E5" /* indigo-600 */,
                    width: "48px",
                    height: "48px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "16px",
                    fontSize: "20px",
                  }}
                >
                  <i className="fas fa-users"></i>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      color: "#111827" /* gray-900 */,
                      lineHeight: "1.25",
                    }}
                  >
                    {summary.totalEmployees || 0}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#6B7280" /* gray-500 */,
                    }}
                  >
                    Total
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Attendance Table */}
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
            }}
          >
            {loading ? (
              <div
                style={{
                  padding: "40px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#6B7280" /* gray-500 */,
                  gap: "16px",
                }}
              >
                <i
                  className="fas fa-spinner fa-spin"
                  style={{
                    fontSize: "32px",
                    color: "#4F46E5" /* indigo-600 */,
                  }}
                ></i>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  Loading attendance data...
                </p>
              </div>
            ) : (
              <div
                style={{
                  overflow: "auto",
                  width: "100%",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "14px",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#F9FAFB" /* gray-50 */,
                        color: "#374151" /* gray-700 */,
                        fontWeight: "500",
                        textAlign: "left",
                        borderBottom: "1px solid #E5E7EB" /* gray-200 */,
                      }}
                    >
                      <th style={{ padding: "16px" }}>Employee</th>
                      <th style={{ padding: "16px" }}>Employee ID</th>
                      <th style={{ padding: "16px" }}>Department</th>
                      <th style={{ padding: "16px" }}>Status</th>
                      <th style={{ padding: "16px" }}>Check In (IST)</th>
                      <th style={{ padding: "16px" }}>Check Out (IST)</th>
                      <th style={{ padding: "16px" }}>Working Hours</th>
                      <th style={{ padding: "16px" }}>Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attendanceData.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          borderBottom: "1px solid #E5E7EB" /* gray-200 */,
                          transition: "background-color 0.2s ease",
                          ":hover": {
                            backgroundColor: "#F9FAFB" /* gray-50 */,
                          },
                        }}
                      >
                        <td style={{ padding: "16px" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                backgroundColor: "#4F46E5" /* indigo-600 */,
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "500",
                                marginRight: "12px",
                                fontSize: "16px",
                              }}
                            >
                              {item.employee.name.charAt(0).toUpperCase()}
                            </div>
                            <div>
                              <div
                                style={{
                                  fontWeight: "500",
                                  color: "#111827" /* gray-900 */,
                                  marginBottom: "2px",
                                }}
                              >
                                {item.employee.name}
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#6B7280" /* gray-500 */,
                                }}
                              >
                                {item.employee.email}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "16px",
                            color: "#4B5563" /* gray-600 */,
                          }}
                        >
                          {item.employee.employeeId || "-"}
                        </td>
                        <td
                          style={{
                            padding: "16px",
                            color: "#4B5563" /* gray-600 */,
                          }}
                        >
                          {item.employee.department || "-"}
                        </td>
                        <td style={{ padding: "16px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              fontWeight: "500",
                              fontSize: "12px",
                              color: getStatusColor(
                                item.attendance.status || "absent"
                              ),
                              backgroundColor: getStatusBgColor(
                                item.attendance.status || "absent"
                              ),
                              textTransform: "uppercase",
                            }}
                          >
                            {item.attendance.status || "absent"}
                          </span>
                        </td>
                        <td style={{ padding: "16px" }}>
                          {item.attendance.checkIn?.time ? (
                            <div>
                              <div
                                style={{
                                  fontWeight: "500",
                                  color: "#111827" /* gray-900 */,
                                }}
                              >
                                {formatTime(item.attendance.checkIn.time)}
                              </div>
                              {item.attendance.isLate && (
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#EF4444" /* red-500 */,
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "4px",
                                  }}
                                >
                                  <i
                                    className="fas fa-exclamation-triangle"
                                    style={{
                                      marginRight: "4px",
                                    }}
                                  ></i>
                                  Late: {item.attendance.lateMinutes}m
                                </div>
                              )}
                            </div>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td
                          style={{
                            padding: "16px",
                            color: "#4B5563" /* gray-600 */,
                            fontWeight: "500",
                          }}
                        >
                          {item.attendance.checkOut?.time
                            ? formatTime(item.attendance.checkOut.time)
                            : "-"}
                        </td>
                        <td
                          style={{
                            padding: "16px",
                            color: "#4B5563" /* gray-600 */,
                            fontWeight: "500",
                          }}
                        >
                          {formatWorkingHours(
                            item.attendance.workingHours?.total
                          )}
                        </td>
                        <td style={{ padding: "16px" }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                            }}
                          >
                            <div
                              style={{
                                color: "#4B5563" /* gray-600 */,
                              }}
                            >
                              {item.attendance.checkIn?.location?.type || "-"}
                            </div>
                            {item.attendance.isManualEntry && (
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#6B7280" /* gray-500 */,
                                  backgroundColor: "#F3F4F6" /* gray-100 */,
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  width: "fit-content",
                                }}
                              >
                                <i
                                  className="fas fa-edit"
                                  style={{
                                    marginRight: "4px",
                                  }}
                                ></i>
                                Manual
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {attendanceData.length === 0 && (
                  <div
                    style={{
                      padding: "60px 20px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#6B7280" /* gray-500 */,
                      textAlign: "center",
                    }}
                  >
                    <i
                      className="fas fa-calendar-times"
                      style={{
                        fontSize: "48px",
                        color: "#D1D5DB" /* gray-300 */,
                        marginBottom: "16px",
                      }}
                    ></i>
                    <h3
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#374151" /* gray-700 */,
                        marginBottom: "8px",
                      }}
                    >
                      No attendance data
                    </h3>
                    <p
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      No attendance records found for the selected date
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Manual Entry Modal - REASON FIELD REMOVED */}
          {showManualEntry && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 50,
              }}
              onClick={() => setShowManualEntry(false)}
            >
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: "500px",
                  maxWidth: "90%",
                  maxHeight: "90vh",
                  overflow: "auto",
                  boxShadow:
                    "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 24px",
                    borderBottom: "1px solid #E5E7EB" /* gray-200 */,
                  }}
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#111827" /* gray-900 */,
                    }}
                  >
                    Add Manual Attendance (IST Times)
                  </h2>
                  <button
                    onClick={() => setShowManualEntry(false)}
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px",
                      borderRadius: "6px",
                      color: "#6B7280" /* gray-500 */,
                      transition: "all 0.2s ease",
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>

                <form
                  onSubmit={handleManualEntry}
                  style={{
                    padding: "24px",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "20px",
                    }}
                  >
                    <label
                      htmlFor="employee-select"
                      style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#374151" /* gray-700 */,
                        marginBottom: "8px",
                      }}
                    >
                      Employee *
                    </label>
                    <select
                      id="employee-select"
                      value={manualForm.employeeId}
                      onChange={(e) =>
                        setManualForm({
                          ...manualForm,
                          employeeId: e.target.value,
                        })
                      }
                      required
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        border: "1px solid #D1D5DB" /* gray-300 */,
                        borderRadius: "6px",
                        fontSize: "14px",
                        color: "#1F2937" /* gray-800 */,
                        outline: "none",
                        backgroundColor: "white",
                        appearance: "none",
                        backgroundImage:
                          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "right 12px center",
                        backgroundSize: "16px 16px",
                        transition: "border-color 0.2s ease",
                      }}
                    >
                      <option value="">Select Employee</option>
                      {employees.map((emp) => (
                        <option key={emp._id} value={emp._id}>
                          {emp.name} - {emp.employeeId || emp.email}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "16px",
                      marginBottom: "20px",
                    }}
                  >
                    <div>
                      <label
                        htmlFor="manual-date"
                        style={{
                          display: "block",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151" /* gray-700 */,
                          marginBottom: "8px",
                        }}
                      >
                        Date *
                      </label>
                      <input
                        id="manual-date"
                        type="date"
                        value={manualForm.date}
                        onChange={(e) =>
                          setManualForm({ ...manualForm, date: e.target.value })
                        }
                        max={new Date().toISOString().split("T")[0]}
                        required
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          border: "1px solid #D1D5DB" /* gray-300 */,
                          borderRadius: "6px",
                          fontSize: "14px",
                          color: "#1F2937" /* gray-800 */,
                          outline: "none",
                          transition: "border-color 0.2s ease",
                        }}
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="manual-status"
                        style={{
                          display: "block",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151" /* gray-700 */,
                          marginBottom: "8px",
                        }}
                      >
                        Status *
                      </label>
                      <select
                        id="manual-status"
                        value={manualForm.status}
                        onChange={(e) =>
                          setManualForm({
                            ...manualForm,
                            status: e.target.value,
                          })
                        }
                        required
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          border: "1px solid #D1D5DB" /* gray-300 */,
                          borderRadius: "6px",
                          fontSize: "14px",
                          color: "#1F2937" /* gray-800 */,
                          outline: "none",
                          backgroundColor: "white",
                          appearance: "none",
                          backgroundImage:
                            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 12px center",
                          backgroundSize: "16px 16px",
                          transition: "border-color 0.2s ease",
                        }}
                      >
                        <option value="present">Present</option>
                        <option value="absent">Absent</option>
                        <option value="late">Late</option>
                        <option value="half-day">Half Day</option>
                        <option value="on-leave">On Leave</option>
                      </select>
                    </div>
                  </div>

                  {manualForm.status !== "absent" && (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <label
                          htmlFor="check-in-time"
                          style={{
                            display: "block",
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#374151" /* gray-700 */,
                            marginBottom: "8px",
                          }}
                        >
                          Check In Time (IST)
                        </label>
                        <input
                          id="check-in-time"
                          type="time"
                          value={manualForm.checkIn}
                          onChange={(e) =>
                            setManualForm({
                              ...manualForm,
                              checkIn: e.target.value,
                            })
                          }
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #D1D5DB" /* gray-300 */,
                            borderRadius: "6px",
                            fontSize: "14px",
                            color: "#1F2937" /* gray-800 */,
                            outline: "none",
                            transition: "border-color 0.2s ease",
                          }}
                        />
                        <small
                          style={{
                            fontSize: "12px",
                            color: "#6B7280",
                            display: "block",
                            marginTop: "4px",
                          }}
                        >
                          Allowed: 9:30 AM - 11:00 AM
                        </small>
                      </div>

                      <div>
                        <label
                          htmlFor="check-out-time"
                          style={{
                            display: "block",
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#374151" /* gray-700 */,
                            marginBottom: "8px",
                          }}
                        >
                          Check Out Time (IST)
                        </label>
                        <input
                          id="check-out-time"
                          type="time"
                          value={manualForm.checkOut}
                          onChange={(e) =>
                            setManualForm({
                              ...manualForm,
                              checkOut: e.target.value,
                            })
                          }
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #D1D5DB" /* gray-300 */,
                            borderRadius: "6px",
                            fontSize: "14px",
                            color: "#1F2937" /* gray-800 */,
                            outline: "none",
                            transition: "border-color 0.2s ease",
                          }}
                        />
                        <small
                          style={{
                            fontSize: "12px",
                            color: "#6B7280",
                            display: "block",
                            marginTop: "4px",
                          }}
                        >
                          Allowed: After 6:00 PM
                        </small>
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "12px",
                      borderTop: "1px solid #E5E7EB" /* gray-200 */,
                      paddingTop: "20px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => setShowManualEntry(false)}
                      style={{
                        padding: "10px 16px",
                        backgroundColor: "#F3F4F6" /* gray-100 */,
                        color: "#4B5563" /* gray-600 */,
                        border: "none",
                        borderRadius: "6px",
                        fontWeight: "500",
                        fontSize: "14px",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={loading}
                      style={{
                        padding: "10px 16px",
                        backgroundColor: "#4F46E5" /* indigo-600 */,
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        fontWeight: "500",
                        fontSize: "14px",
                        cursor: loading ? "not-allowed" : "pointer",
                        opacity: loading ? "0.7" : "1",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {loading ? "Adding..." : "Add Attendance"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminAttendanceManagement;